export default "__VITE_ASSET__C6rX4syq__"